import { Component, forwardRef, AfterViewInit, Input, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl } from '@angular/forms';

import * as appConfig from '../../../../../app.config';

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => WysiwygComponent),
  multi: true
};

@Component({
  selector: 'swb-wysiwyg',
  templateUrl: './wysiwyg.component.html',
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class WysiwygComponent implements ControlValueAccessor, AfterViewInit, OnDestroy {

  @Input() key: string;
  @Input() height: number;
  @Input() initValue: string;
  @Input() control: FormControl;
  @Input() ident: string;

  private onTouchedCallback: () => void = noop;
  private _onModelChanged: Function;

  private _value: string;
  private _initialized = false;

  public editor: any;

  get value(): any {
    let content: string;
    if (typeof this.editor !== 'undefined') {
      content = this.editor.getContent();
    } else {
      content = '';
    }
    this._value = content;
    return this._value;
  };

  // From ControlValueAccessor interface
  writeValue(value: string) {
    // noop
    this._value = value;
  }

  public registerOnChange(fn: Function): void {
    this._onModelChanged = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  public ngAfterViewInit(): void {
    this._initMce();
  }

  public ngOnDestroy(): void {
    tinymce.remove(this.editor);
  }

  private _initMce() {

    // setup wysiwyg now
    tinymce.init({
      selector: '#' + this.key + (this.ident ? this.ident : ''),
      plugins: appConfig.mceConfig.plugins,
      toolbar: appConfig.mceConfig.toolbar,
      menubar: appConfig.mceConfig.menuBar,
      statusbar: appConfig.mceConfig.statusBar,
      elementpath: appConfig.mceConfig.elementpath,
      language_url: appConfig.mceConfig.langUrl,
      skin_url: appConfig.mceConfig.skinUrl,
      branding: appConfig.mceConfig.branding,
      height: this.height,
      relative_urls: appConfig.mceConfig.relativeUrls,
      remove_script_host: appConfig.mceConfig.removeScriptHost,
      convert_urls: appConfig.mceConfig.convertUrls,
      media_alt_source: appConfig.mceConfig.mediaAltSource,
      media_poster: appConfig.mceConfig.mediaPoster,
      media_dimensions: appConfig.mceConfig.mediaDimensions,
      image_caption: appConfig.mceConfig.imageCaption,
      file_picker_callback: (callback, value, meta) => {
        this._initFilepicker(callback, value, meta);
      },
      file_picker_types: appConfig.mceConfig.filePickerTypes,
      init_instance_callback: editor => {
        this._initialized = true;
        editor.setContent(this.initValue);
        editor.on('Blur', () => {
          this.onTouchedCallback();
        });
        editor.on('NodeChange', () => {
          this._onModelChanged(editor.getContent());
        });
        editor.on('keyup', () => {
          this._onModelChanged(editor.getContent());
        });
        editor.on('change', () => {
          this._onModelChanged(editor.getContent());
        });
        this.editor = editor;

      }
    });
  }


  private _initFilepicker(callback, value, meta): void {
    tinymce.activeEditor.windowManager.open({
      title: 'Vyberte obrázek',
      url: '/mce-browse',
      width: 780,
      height: 550
    }, {
        oninsert: function (url) {
          callback(url);
        }
      });
  }

}
